// extracted by mini-css-extract-plugin
module.exports = {"details":"StepHeading_details__4gr0F","title":"StepHeading_title__mS0qm","description":"StepHeading_description__NZnZn"};